
export class MapIconIMG {

    flecha(w_ico, h_ico, rotate) {
        let verde = '#4EBA75';
        let azul = '#01579B';
        var icon = `
            <svg width="${w_ico}" height="${h_ico}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <style type="text/css">.st0{fill:${azul};}</style>
              <g transform='rotate(${rotate} 50 50)'>
                <path class="st0" d="m50.01,15c11.68,23.37 23.3,46.6 34.99,69.98c-0.28,-0.17 -0.43,-0.25 -0.58,-0.35c-10.84,-7.23 -21.69,-14.46 -32.53,-21.69c-1.4,-0.93 -2.37,-0.93 -3.79,0.01c-10.83,7.23 -21.66,14.45 -32.49,21.66c-0.15,0.1 -0.3,0.2 -0.61,0.39c11.7,-23.39 23.32,-46.64 35.01,-70z" id="svg_2"/>
              </g>
            </svg>
        `;
        return icon;
    }

    stop(w_ico, h_ico, color) {
        var icon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="` + w_ico + `" height="` + h_ico + `" viewBox="0 0 44 44">
            <style type="text/css">
                .blanco{fill:#FFFFFF;}
                .rojo{fill:`+ color + `;}
            </style>
            <polygon class="blanco" points="29.6 3.7 14.4 3.7 3.7 14.4 3.7 29.6 14.4 40.3 29.6 40.3 40.3 29.6 40.3 14.4 "/>
            <path class="rojo" d="M31.1 0H12.9L0 12.9v18.2l8.2 8.2c1.4 1.6 3 3.2 4.7 4.8h18.3c1.3-1.2 2.5-2.4 3.6-3.6l9.3-9.3V12.9L31.1 0zM40.3 29.6L29.6 40.3H14.4L3.7 29.6V14.4L14.4 3.7h15.2l10.7 10.7V29.6z"/>
            <path class="rojo" d="M13.4 21.9c-1.6-0.7-2.3-0.8-2.3-1.8 0-1.3 1.4-1.3 1.8-0.7 0.1 0.2 0.2 0.6 0.2 1h1.7v-0.3c0-0.4-0.1-0.8-0.2-1.1 -0.5-1-1.5-1.3-2.6-1.3 -0.9 0-1.5 0.2-2 0.7 -1.1 0.9-1.2 3.3 0.6 4.3 1 0.6 2.3 0.6 2.6 1.5 0.1 0.3 0.2 1-0.3 1.4 -0.5 0.4-1.3 0.4-1.7-0.1C11 25 11 24.5 11 24H9.2c0 0.9 0 1.6 0.7 2.3 0.9 0.9 3.4 0.9 4.5 0C15.5 25.4 15.7 22.9 13.4 21.9z"/>
            <polygon class="rojo" points="15.6 19.3 17.6 19.3 17.6 26.8 19.4 26.8 19.4 19.3 21.3 19.3 21.3 17.8 15.6 17.8 "/>
            <path class="rojo" d="M26.6 18c-0.8-0.5-2.4-0.5-3.3 0 -0.4 0.2-0.7 0.6-0.9 1 -0.7 1.3-0.7 5.4 0 6.7 0.2 0.4 0.5 0.7 0.9 0.9 0.8 0.4 2.4 0.4 3.3 0 0.4-0.2 0.7-0.5 0.9-0.9 0.7-1.3 0.7-5.4 0-6.7C27.3 18.6 27 18.2 26.6 18zM26 24.9c-0.3 1-1.7 1-2.1 0 -0.3-0.9-0.3-4.2 0-5.2 0.3-1.1 1.7-1.1 2.1 0C26.3 20.7 26.3 24 26 24.9z"/>
            <path class="rojo" d="M29.1 26.8H31v-3.6c1 0 1.5 0 2.1-0.2 2.4-0.7 2.4-5.3-0.8-5.3h-3.2V26.8zM31 19.2c0.8 0 1.4-0.1 1.7 0.4 0.4 0.5 0.4 1.6 0 2.1 -0.4 0.4-0.8 0.3-1.7 0.3V19.2z"/>
        </svg>
        `;
        return icon;
    }

    alerta(color?) {
        var icon = `
        <svg width="20" height="20" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve">
        <style type="text/css">
          .alertaSt0{fill:#F1C40F;}
          .alertaSt1{fill:#34495E;}
        </style>
        <path class="alertaSt0" d="M10,0C9,0,8.3,0.8,8,1.6C5.4,6.8,2.8,12,0.2,17.3c-0.6,1.3,0.6,2.9,2,2.8c2.6,0,5.2,0,7.8,0c2.6,0,5.2,0,7.8,0
          c1.4,0.2,2.6-1.4,2-2.8C17.3,12,14.6,6.8,12,1.6C11.7,0.8,11,0,10,0z"/>
        <path class="alertaSt1" d="M10,4.5c-0.6,0-1,0.4-1,1l0.5,7h1l0.5-7C11,5,10.6,4.5,10,4.5z M10,13.5c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1
          S10.6,13.5,10,13.5z"/>
        </svg>
        `;
        return icon;
    }

    eventoContacto(codEvento?) {
      let tipo = (codEvento==24) ? '#FF415B' :  '#49BC31';
      let evento = '';
      if (codEvento==23){
        evento = `
        <g>
            <path d="M23.3,59c0-2.6,0.4-4.9,1.3-7s2.1-3.9,3.6-5.3c1.5-1.5,3.4-2.6,5.5-3.4c2.1-0.8,4.4-1.2,7-1.2s4.8,0.4,7,1.2
              c2.1,0.8,4,1.9,5.5,3.4c1.5,1.5,2.8,3.3,3.6,5.3s1.3,4.4,1.3,7c0,2.6-0.4,4.9-1.3,7s-2.1,3.9-3.6,5.3c-1.5,1.5-3.4,2.6-5.5,3.4
              c-2.1,0.8-4.4,1.2-7,1.2s-4.8-0.4-7-1.2c-2.1-0.8-4-1.9-5.5-3.4c-1.5-1.5-2.8-3.3-3.6-5.3S23.3,61.6,23.3,59z M30.7,59
              c0,1.5,0.2,2.9,0.7,4.2c0.5,1.3,1.1,2.3,2,3.3c0.9,0.9,1.9,1.6,3.2,2.2c1.2,0.5,2.6,0.8,4.1,0.8c1.5,0,2.9-0.3,4.1-0.8
              c1.2-0.5,2.3-1.2,3.2-2.2c0.9-0.9,1.6-2,2-3.3c0.5-1.3,0.7-2.6,0.7-4.2c0-1.5-0.2-2.9-0.7-4.1c-0.5-1.3-1.1-2.4-2-3.3
              c-0.9-0.9-1.9-1.6-3.2-2.2c-1.2-0.5-2.6-0.8-4.1-0.8c-1.5,0-2.9,0.3-4.1,0.8c-1.2,0.5-2.3,1.2-3.2,2.2c-0.9,0.9-1.6,2-2,3.3
              C30.9,56.2,30.7,57.6,30.7,59z"/>
            <path d="M62.9,43h9.6l13.7,22.4h0.1V43h7.1v32.2h-9.3l-14-22.9H70v22.9h-7.1V43z"/>
        </g>`
      }
      if (codEvento==24){
        evento = `
        <g>
          <path d="M20.9,59.9c0-2.3,0.4-4.4,1.2-6.2s1.8-3.5,3.2-4.8c1.4-1.3,3-2.3,4.9-3c1.9-0.7,4-1.1,6.2-1.1c2.2,0,4.3,0.4,6.2,1.1
            c1.9,0.7,3.5,1.7,4.9,3c1.4,1.3,2.5,2.9,3.2,4.8s1.2,3.9,1.2,6.2c0,2.3-0.4,4.4-1.2,6.2s-1.8,3.5-3.2,4.8c-1.4,1.3-3,2.3-4.9,3
            c-1.9,0.7-4,1.1-6.2,1.1c-2.2,0-4.3-0.4-6.2-1.1c-1.9-0.7-3.5-1.7-4.9-3c-1.4-1.3-2.5-2.9-3.2-4.8S20.9,62.2,20.9,59.9z M27.5,59.9
            c0,1.4,0.2,2.6,0.6,3.7c0.4,1.1,1,2.1,1.8,2.9c0.8,0.8,1.7,1.5,2.8,1.9c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7
            c1.1-0.5,2-1.1,2.8-1.9c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.6-2.4,0.6-3.7c0-1.3-0.2-2.6-0.6-3.7c-0.4-1.1-1-2.1-1.8-2.9
            c-0.8-0.8-1.7-1.5-2.8-1.9c-1.1-0.5-2.3-0.7-3.7-0.7c-1.4,0-2.6,0.2-3.7,0.7c-1.1,0.5-2,1.1-2.8,1.9c-0.8,0.8-1.4,1.8-1.8,2.9
            C27.7,57.4,27.5,58.6,27.5,59.9z"/>
          <path d="M56.4,45.6h19.3v5.8H62.7v5.8h12v5.8h-12v11.2h-6.3V45.6z"/>
          <path d="M80.5,45.6h19.3v5.8H86.8v5.8h12v5.8h-12v11.2h-6.3V45.6z"/>
        </g>
        `;
      }
        var icon = `
        <svg width="30" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 120 146.3" style="enable-background:new 0 0 120 146.3;" xml:space="preserve">
        <style type="text/css">
          .eventoSt0${codEvento}{fill:${tipo};}
          .eventoSt1${codEvento}{opacity:0.2;fill:#000000;}
        </style>
        <path class="eventoSt0${codEvento}" d="M60,0C26.9,0,0,26.9,0,60c0,26.7,17.6,50.1,43,57.6l13.2,26.4c0.7,1.5,2.2,2.4,3.8,2.4c1.6,0,3.1-0.9,3.8-2.4
          L77,117.6c25.4-7.5,43-30.9,43-57.6C120,26.9,93.1,0,60,0z M83.6,102.1C83.6,102.1,83.6,102.1,83.6,102.1c-7,3.9-15.1,6.2-23.6,6.2
          c-9,0-17.4-2.5-24.6-6.7c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0c-14-8.5-23.4-23.8-23.4-41.4
          c0-26.6,21.7-48.3,48.3-48.3s48.3,21.7,48.3,48.3C108.3,78.1,98.3,93.8,83.6,102.1z"/>
        <path class="eventoSt1${codEvento}" d="M60,0C60,0,60,0,60,0l0,11.7c0,0,0,0,0,0c26.6,0,48.3,21.7,48.3,48.3c0,18.1-10,33.8-24.7,42.1c0,0,0,0-0.1,0
          c-7,3.9-15,6.1-23.5,6.1c0,0,0,0,0,0v38c0,0,0,0,0,0c1.6,0,3.1-0.9,3.8-2.4L77,117.6c25.4-7.5,43-30.9,43-57.6C120,26.9,93.1,0,60,0
          z"/>
        ${evento}        
        </svg>
        `;
        return icon;
    }

    punto(color) {
      var w_ico = 25;
      var h_ico = 25;
      var icon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${w_ico}" height="${h_ico}" viewBox="0 0 44 44">
            <style type="text/css">
              .detalle{fill:#FFFFFF;}
              .rojo{fill:${color};}
            </style>
            <g>
                <path class="rojo" d="M14.5,0C6.5,0,0,6.6,0,14.7c0,0.3,0,0.6,0,0.9c0.1,1.2,0.3,2.4,0.7,3.6c0.4,1.1,0.9,2.2,1.5,3.2
                    c0,0.1,0.4,0.6,1.1,1.6c0,0,0,0,0,0c2.8,4.2,10.1,15.3,10.1,15.4c0.5,0.8,1.6,0.8,2.2,0c0,0,0.1-0.1,0.1-0.1
                    c0.1-0.2,10.9-16.5,11.2-17c0.1-0.2,0.2-0.3,0.3-0.5c0.6-1,1-2.1,1.3-3.2c0.4-1.3,0.5-2.6,0.5-4C29,6.6,22.5,0,14.5,0z"/>
                <path class="detalle" d="M2.2,9.4c0,0,3.5-8.4,12.2-7.8c0,0,2.6,0,2.6,1.2c0,1.5-2.6,1-2.6,1S6.8,2.9,2.2,9.4z"/>
            </g>
        </svg>
        `;
        return icon;
    }   

    auto(w_ico, h_ico, color, rotate){
        var icon = `        
        <svg width="${w_ico}" height="${h_ico}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100">
        <defs>
          <style>
            .a { isolation: isolate; }
            .b { fill: #fff;opacity: 0; }      
            .ak, .c { mix-blend-mode: multiply; }      
            .c { fill: url(#a); }      
            .d { fill: ${color}; }      
            .e { fill: url(#b); }      
            .f { fill: url(#c); }      
            .g { fill: url(#d); }      
            .h { fill: url(#e); }      
            .i { fill: url(#f); }      
            .j { fill: url(#g); }      
            .k { fill: url(#h); }      
            .l { fill: url(#i); }      
            .m { fill: #d62029; }      
            .n { opacity: 0.1; }
            .aa, .ab, .ac, .ad, .aj, .o {  mix-blend-mode: screen; }      
            .o { fill: url(#j); }      
            .p { fill: url(#k); }      
            .q { fill: url(#l); }      
            .r { fill: url(#m); }      
            .s { fill: url(#n); }      
            .t { fill: url(#o); }      
            .u { fill: url(#p); }      
            .v { fill: #595a5a; }      
            .w { fill: #9e9e9e; }      
            .x { fill: url(#q); }      
            .y { fill: url(#r); }      
            .z { fill: url(#s); }      
            .aa { fill: url(#t); }      
            .ab { fill: url(#u); }      
            .ac { fill: url(#v); }      
            .ad { fill: url(#w); }      
            .ae { fill: url(#x); }      
            .af { fill: url(#y); }      
            .ag { fill: url(#z); }      
            .ah { fill: url(#aa); }      
            .ai { fill: url(#ab); }      
            .aj { fill: url(#ac); }
          </style>
          <linearGradient id="a" x1="43.49" y1="45.15" x2="68.71" y2="45.15" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#242424"/>
            <stop offset="1" stop-color="#fff" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="b" x1="35.49" y1="2.83" x2="54.53" y2="2.83" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#535a57"/>
            <stop offset="1" stop-color="#010101"/>
          </linearGradient>
          <linearGradient id="c" x1="31.08" y1="38.32" x2="58.95" y2="38.32" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#010101"/>
            <stop offset="1" stop-color="#1b1c1c"/>
          </linearGradient>
          <linearGradient id="d" x1="28.87" y1="24.14" x2="61.15" y2="24.14" xlink:href="#c"/>
          <linearGradient id="e" x1="29.01" y1="30.85" x2="61.01" y2="30.85" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#373c3a"/>
            <stop offset="1" stop-color="#1b1c1c"/>
          </linearGradient>
          <linearGradient id="f" x1="27.78" y1="42.54" x2="30.93" y2="42.54" xlink:href="#e"/>
          <linearGradient id="g" x1="59.09" y1="42.53" x2="62.25" y2="42.53" xlink:href="#e"/>
          <linearGradient id="h" x1="28" y1="69.86" x2="31.26" y2="69.86" xlink:href="#e"/>
          <linearGradient id="i" x1="58.76" y1="69.84" x2="62.02" y2="69.84" xlink:href="#e"/>
          <linearGradient id="j" x1="44.92" y1="27.64" x2="53.93" y2="34.04" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#373c3a"/>
            <stop offset="1" stop-color="#010101"/>
          </linearGradient>
          <linearGradient id="k" x1="61.66" y1="27.76" x2="65.15" y2="34.52" xlink:href="#e"/>
          <linearGradient id="l" x1="62.54" y1="29.68" x2="67.72" y2="29.68" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff"/>
            <stop offset="1" stop-color="#d3d6d5"/>
          </linearGradient>
          <linearGradient id="m" x1="62.51" y1="30.38" x2="67.69" y2="30.38" xlink:href="#e"/>
          <linearGradient id="n" x1="-2774.1" y1="27.76" x2="-2770.61" y2="34.52" gradientTransform="matrix(-1, 0, 0, 1, -2745.89, 0)" xlink:href="#e"/>
          <linearGradient id="o" x1="-2773.22" y1="29.68" x2="-2768.04" y2="29.68" gradientTransform="matrix(-1, 0, 0, 1, -2745.89, 0)" xlink:href="#l"/>
          <linearGradient id="p" x1="-2773.25" y1="30.38" x2="-2768.07" y2="30.38" gradientTransform="matrix(-1, 0, 0, 1, -2745.89, 0)" xlink:href="#e"/>
          <linearGradient id="q" x1="38.88" y1="89.67" x2="51.13" y2="89.67" xlink:href="#j"/>
          <radialGradient id="r" cx="64.33" cy="4.82" r="3.45" gradientTransform="translate(-4.65) scale(0.99 1)" xlink:href="#l"/>
          <radialGradient id="s" cx="-2790.68" cy="4.82" r="3.45" gradientTransform="matrix(-0.99, 0, 0, 1, -2718.77, 0)" xlink:href="#l"/>
          <linearGradient id="t" x1="28" y1="66" x2="31.09" y2="66" xlink:href="#j"/>
          <linearGradient id="u" x1="27.78" y1="38.88" x2="30.56" y2="38.88" xlink:href="#j"/>
          <linearGradient id="v" x1="-2812.32" y1="65.98" x2="-2809.23" y2="65.98" gradientTransform="matrix(-1, 0, 0, 1, -2750.22, 0)" xlink:href="#j"/>
          <linearGradient id="w" x1="-2812.54" y1="38.87" x2="-2809.76" y2="38.87" gradientTransform="matrix(-1, 0, 0, 1, -2750.22, 0)" xlink:href="#j"/>
          <linearGradient id="x" x1="40.18" y1="12.52" x2="48.84" y2="12.52" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#d2dcdb"/>
            <stop offset="1" stop-color="#b5b6b6"/>
          </linearGradient>
          <linearGradient id="y" x1="40.18" y1="13.48" x2="48.84" y2="13.48" xlink:href="#x"/>
          <linearGradient id="z" x1="40.18" y1="14.44" x2="48.84" y2="14.44" xlink:href="#x"/>
          <linearGradient id="aa" x1="40.18" y1="15.4" x2="48.84" y2="15.4" xlink:href="#x"/>
          <linearGradient id="ab" x1="31.28" y1="84.17" x2="58.65" y2="84.17" xlink:href="#e"/>
          <linearGradient id="ac" x1="40.68" y1="75.22" x2="46.58" y2="84.26" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#5e5f5f"/>
            <stop offset="1" stop-color="#010101"/>
          </linearGradient>
        </defs>
        <title>mapIcon</title>
        <g class="a" transform='rotate(`+ rotate + ` 50 50)'>
          <g>
            <rect class="b" width="90" height="90"/>
            <g>
              <path class="c" d="M54.55,87.43H41.35A13.23,13.23,0,0,1,28,74.28V16A13.23,13.23,0,0,1,41.35,2.88h13.2A13.23,13.23,0,0,1,67.86,16V74.28A13.23,13.23,0,0,1,54.55,87.43Z"/>
              <path class="d" d="M64.75,14.47c-.45-4-1.17-6-2.46-7.67a2,2,0,0,1-1.59-.35L56.06,3a2.16,2.16,0,0,1-.85-1.49l-.68-.23V5.65h-19V1.28l-.67.23A2.21,2.21,0,0,1,34,3L29.32,6.45a2,2,0,0,1-1.59.35c-1.28,1.65-2,3.7-2.46,7.67-1.2,10.5.83,27,.78,31.08-.26,21.69-.44,34.9,1,39.47a4.12,4.12,0,0,0,1.87,2.17,1.75,1.75,0,0,1,.73-.15c1.66,0,2.46,1.09,4.29.78,1.21-.21,1.62.81,1.76,1.52,1.08.17,2.17.3,3.2.4a.94.94,0,0,1,.76-.4H50.37a.94.94,0,0,1,.76.4c.77-.07,1.57-.16,2.38-.27.12-.72.5-1.87,1.78-1.65,1.83.31,2.63-.78,4.29-.78a1.46,1.46,0,0,1,1.11.42A4.49,4.49,0,0,0,63,85c1.41-4.57,1.24-17.78,1-39.47C63.92,41.48,66,25,64.75,14.47Z"/>
              <path class="e" d="M54.53,5.65V1.28a36,36,0,0,0-19,0V5.65Z"/>
              <path class="d" d="M63.57,15.12c-.74-6.59-2.22-7.69-5.87-10.78-5-4.2-20.42-4.2-25.37,0-3.65,3.09-5.14,4.19-5.87,10.78-1.13,10.11.78,26,.73,29.92-.25,20.87-.42,33.58.92,38C29.64,88.1,45,87.82,45,87.82S60.38,88.1,61.92,83c1.33-4.41,1.16-17.12.91-38C62.79,41.12,64.69,25.23,63.57,15.12Z"/>
              <path class="f" d="M37.44,36.92a25.44,25.44,0,0,0-6.36,1.73l.25,1.44a22.55,22.55,0,0,1,6.44-1.89,68.81,68.81,0,0,1,14.49,0,22.55,22.55,0,0,1,6.44,1.89L59,38.65a25.42,25.42,0,0,0-6.37-1.73A76.59,76.59,0,0,0,37.44,36.92Z"/>
              <path class="g" d="M30.08,26.07a34.59,34.59,0,0,1,6.82-2.21,41,41,0,0,1,16.22,0,34.59,34.59,0,0,1,6.82,2.21,3.22,3.22,0,0,1,1.07.64v0a3.5,3.5,0,0,0,.08-1.33,2.46,2.46,0,0,0-1.16-.76,34.59,34.59,0,0,0-6.82-2.21,41,41,0,0,0-16.22,0,34.59,34.59,0,0,0-6.82,2.21,2.46,2.46,0,0,0-1.16.76A3.68,3.68,0,0,0,29,26.67v0A3.34,3.34,0,0,1,30.08,26.07Z"/>
              <path class="h" d="M37.44,36.92a76.59,76.59,0,0,1,15.14,0A25.42,25.42,0,0,1,59,38.65L61,26.71a3.22,3.22,0,0,0-1.07-.64,34.59,34.59,0,0,0-6.82-2.21,41,41,0,0,0-16.22,0,34.59,34.59,0,0,0-6.82,2.21,3.34,3.34,0,0,0-1.07.64l2.07,11.94A25.44,25.44,0,0,1,37.44,36.92Z"/>
              <path class="i" d="M28.22,57.65l2.71,1.12-.46-14.86L27.88,26.3s-.23,4.51,0,11c.14,4.09.54,9.73.54,13.37C28.41,54.11,28.31,56.45,28.22,57.65Z"/>
              <path class="j" d="M61.8,57.63l-2.71,1.13.47-14.86,2.59-17.6s.22,4.51,0,11c-.15,4.1-.55,9.73-.54,13.36C61.62,54.09,61.7,56.46,61.8,57.63Z"/>
              <path class="k" d="M28.14,59,31,60.46l.31,12.43A20,20,0,0,1,30,77a18,18,0,0,1-1.83,3.72S27.83,63.68,28.14,59Z"/>
              <path class="l" d="M61.88,59l-2.81,1.43-.31,12.43A20,20,0,0,0,60.05,77a18.75,18.75,0,0,0,1.83,3.72S62.19,63.66,61.88,59Z"/>
              <path class="m" d="M33.92,87.82c-1.83.31-2.63-.78-4.29-.78a1.75,1.75,0,0,0-.73.15,18.66,18.66,0,0,0,6.78,2.15C35.54,88.63,35.13,87.61,33.92,87.82Z"/>
              <path class="m" d="M55.29,87.82c-1.28-.22-1.66.93-1.78,1.65a22.14,22.14,0,0,0,7.18-2A1.46,1.46,0,0,0,59.58,87C57.92,87,57.12,88.13,55.29,87.82Z"/>
              <path class="n" d="M32.11,21.56s3.14-5.81,3.57-8c.33-1.65-.19-6.75-.19-6.75s-.33,4.86-.67,6.44C34.36,15.42,32.11,21.56,32.11,21.56Z"/>
              <path class="n" d="M58,21.56s-3.14-5.81-3.57-8c-.33-1.65.18-6.75.18-6.75s.34,4.86.68,6.44C55.7,15.42,58,21.56,58,21.56Z"/>
              <path class="o" d="M59.94,26.07a34.59,34.59,0,0,0-6.82-2.21,32.73,32.73,0,0,0-3.81-.59C45.89,27,41.84,33.8,40.18,36.67a78.18,78.18,0,0,1,12.4.25A25.42,25.42,0,0,1,59,38.65L61,26.71A3.22,3.22,0,0,0,59.94,26.07Z"/>
              <path class="d" d="M45,38.32c-9.94-.23-13.27,2.43-13.27,2.43s.12,37.62.88,40.05c.51,1.65,6.77,1,10.75,1.34h3.28c4-.3,10.24.31,10.76-1.34.75-2.43.88-40,.88-40S55,38.09,45,38.32Z"/>
              <path class="n" d="M34,3.78s-6,3.07-6.62,9.89a96.9,96.9,0,0,0-.55,10.47S28.83,7.48,34,3.78Z"/>
              <path class="n" d="M56.11,3.78s6,3.07,6.62,9.89a96.9,96.9,0,0,1,.55,10.47S61.23,7.48,56.11,3.78Z"/>
              <path class="p" d="M62,27.21s1.55.31,1.59,1.66S62.07,33,62,31.22A30,30,0,0,1,62,27.21Z"/>
              <path class="q" d="M67.67,30.15c0-.85-4.05-1.94-4.17-1.64-.87,0-1,.64-.9,1.1a7.11,7.11,0,0,1,4.95,1.29A.79.79,0,0,0,67.67,30.15Z"/>
              <path class="r" d="M62.51,29.62a2.27,2.27,0,0,0,.15.56,7,7,0,0,1,4.77,1,1.43,1.43,0,0,0,.22-.24A7.33,7.33,0,0,0,62.51,29.62Z"/>
              <path class="s" d="M27.83,27.21s-1.55.31-1.59,1.66,1.55,4.08,1.59,2.35A30,30,0,0,0,27.83,27.21Z"/>
              <path class="t" d="M22.19,30.15c0-.85,4-1.94,4.17-1.64.87,0,1,.64.9,1.1a7.08,7.08,0,0,0-4.94,1.29A.79.79,0,0,1,22.19,30.15Z"/>
              <path class="u" d="M27.35,29.62a2.27,2.27,0,0,1-.15.56,7,7,0,0,0-4.77,1,1.19,1.19,0,0,1-.21-.24A7.3,7.3,0,0,1,27.35,29.62Z"/>
              <path class="v" d="M26.1,44.92a.41.41,0,0,0-.41.42v3.47a.41.41,0,0,0,.41.42Z"/>
              <path class="v" d="M25.89,62.29a.41.41,0,0,0-.41.42v3.47a.41.41,0,0,0,.41.42Z"/>
              <path class="v" d="M63.93,44.92a.42.42,0,0,1,.41.42v3.47a.42.42,0,0,1-.41.42Z"/>
              <path class="v" d="M64.13,62.29a.41.41,0,0,1,.41.42v3.47a.41.41,0,0,1-.41.42Z"/>
              <g>
                <path class="w" d="M36,20.3c.66-.05,1-.43,1.66-.48a.12.12,0,0,0,.1-.11.09.09,0,0,0-.1-.09c-.67.05-1,.43-1.66.49a.09.09,0,0,0-.1.1A.09.09,0,0,0,36,20.3Z"/>
                <path class="w" d="M37.69,20c-.67.06-1,.44-1.66.49a.12.12,0,0,0-.1.11.09.09,0,0,0,.1.09c.66-.05,1-.44,1.66-.49a.11.11,0,0,0,.1-.1A.1.1,0,0,0,37.69,20Z"/>
                <path class="w" d="M37.69,20.41c-.67.05-1,.43-1.66.49a.1.1,0,0,0-.1.1.09.09,0,0,0,.1.1c.66-.06,1-.44,1.66-.49a.12.12,0,0,0,.1-.1A.1.1,0,0,0,37.69,20.41Z"/>
              </g>
              <g>
                <path class="w" d="M54,20.3c-.66-.05-1-.43-1.66-.48a.12.12,0,0,1-.1-.11.09.09,0,0,1,.1-.09c.67.05,1,.43,1.66.49a.1.1,0,0,1,.1.1A.09.09,0,0,1,54,20.3Z"/>
                <path class="w" d="M52.32,20c.67.06,1,.44,1.66.49a.12.12,0,0,1,.1.11.1.1,0,0,1-.1.09c-.66-.05-1-.44-1.66-.49a.11.11,0,0,1-.1-.1A.1.1,0,0,1,52.32,20Z"/>
                <path class="w" d="M52.32,20.41c.67.05,1,.43,1.66.49a.11.11,0,0,1,.1.1.1.1,0,0,1-.1.1c-.66-.06-1-.44-1.66-.49a.12.12,0,0,1-.1-.1A.1.1,0,0,1,52.32,20.41Z"/>
              </g>
              <path class="x" d="M50.37,89.34H39.64a.94.94,0,0,0-.76.4C42.25,90.05,45,90,45,90s2.76,0,6.12-.26A.94.94,0,0,0,50.37,89.34Z"/>
              <path class="y" d="M57.7,4.34a20.18,20.18,0,0,1,3.83,3.78c.24-.32.37-1.24.76-1.32A23.78,23.78,0,0,0,58.5,3.27a10.85,10.85,0,0,0-3.29-1.76,6.35,6.35,0,0,0,.43,1.57A8.77,8.77,0,0,1,57.7,4.34Z"/>
              <path class="z" d="M32.36,4.34a20,20,0,0,0-3.84,3.78c-.23-.32-.36-1.24-.76-1.32a23.78,23.78,0,0,1,3.79-3.53,10.79,10.79,0,0,1,3.3-1.76,6.82,6.82,0,0,1-.43,1.57A8.57,8.57,0,0,0,32.36,4.34Z"/>
              <path class="aa" d="M31,60.46,28.14,59C28,61.57,28,67.83,28,73a16.7,16.7,0,0,0,3.05-7.13Z"/>
              <path class="ab" d="M28.41,51.45a17.31,17.31,0,0,0,2.15-4.55l-.09-3L27.88,26.3s-.23,4.51,0,11c.14,4.09.54,9.73.54,13.37C28.41,50.93,28.41,51.19,28.41,51.45Z"/>
              <path class="ac" d="M59.15,60.44,62,59c.17,2.55.15,8.8.1,13.94a16.75,16.75,0,0,1-3-7.13Z"/>
              <path class="ad" d="M61.69,51.44a17.63,17.63,0,0,1-2.15-4.55l.1-3,2.58-17.6s.23,4.51,0,11c-.14,4.1-.54,9.73-.53,13.36Z"/>
              <rect class="ae" x="40.18" y="12.32" width="8.66" height="0.4"/>
              <rect class="af" x="40.18" y="13.28" width="8.66" height="0.4"/>
              <rect class="ag" x="40.18" y="14.24" width="8.66" height="0.4"/>
              <rect class="ah" x="40.18" y="15.2" width="8.66" height="0.4"/>
              <g>
                <path class="ai" d="M32.59,80.1a17.44,17.44,0,0,0-1.3,5.41c-.14.65,2.65,1.25,6.66,2.13,3.07.8,11,.82,14.08,0,4-.86,6.73-1.41,6.62-2.24a16.1,16.1,0,0,0-1.21-5.23A35,35,0,0,1,45,82.25,36,36,0,0,1,32.59,80.1Z"/>
                <path class="aj" d="M57.68,80.12a35.16,35.16,0,0,1-12.43,2.11c-1.29,0-2.5-.06-3.64-.17-3.62.87-6.46,4-7.15,4.79,1,.35,2.37.49,3.76.79a41.6,41.6,0,0,0,14.08,0,28.78,28.78,0,0,0,6.6-2.26A14.58,14.58,0,0,0,57.68,80.12Z"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
      `;
        return icon;
    }

    combustible(color?){
      var w_ico = 25;
      var h_ico = 25;
      var icon = `<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="mdi-fuel" width="25" height="25" viewBox="0 0 24 24"><path d="M3,2H6C6.28,2 6.53,2.11 6.71,2.29L8.79,4.38L9.59,3.59C10,3.2 10.5,3 11,3H17C17.5,3 18,3.2 18.41,3.59L19.41,4.59C19.8,5 20,5.5 20,6V19A2,2 0 0,1 18,21H8A2,2 0 0,1 6,19V13L6,12V8C6,7.5 6.2,7 6.59,6.59L7.38,5.79L5.59,4H3V2M11,5V7H17V5H11M11.41,11L9.41,9H8V10.41L10,12.41V15.59L8,17.59V19H9.41L11.41,17H14.59L16.59,19H18V17.59L16,15.59V12.41L18,10.41V9H16.59L14.59,11H11.41M12,13H14V15H12V13Z" /></svg>`;
      return icon;
    }
    
    temperatura(color?){
      var icon = `
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
       width="25" height="25" viewBox="0 0 640.000000 1280.000000"
       preserveAspectRatio="xMidYMid meet">
      
      <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
      fill="#EE5B2F" stroke="none">
      <path d="M3033 12785 c-93 -17 -162 -40 -248 -83 -255 -127 -432 -345 -507
      -623 l-23 -84 -5 -4232 -5 -4232 -85 -56 c-437 -292 -714 -707 -821 -1233 -27
      -130 -36 -423 -19 -570 94 -797 686 -1452 1471 -1626 990 -219 1982 385 2238
      1365 50 191 56 247 56 489 0 239 -8 301 -61 499 -91 337 -299 673 -560 903
      -85 76 -213 171 -281 209 l-43 24 0 518 0 517 325 0 325 0 0 120 0 120 -325 0
      -325 0 0 765 0 765 325 0 325 0 0 120 0 120 -325 0 -325 0 0 765 0 765 325 0
      325 0 0 120 0 120 -322 2 -323 3 -3 763 -2 762 325 0 325 0 0 125 0 125 -325
      0 -325 0 0 913 c0 850 -2 918 -19 1002 -38 186 -127 345 -270 485 -219 213
      -524 309 -818 255z m340 -349 c189 -60 340 -209 405 -400 l27 -81 3 -4312 2
      -4312 118 -69 c310 -184 502 -381 646 -664 254 -498 227 -1079 -72 -1543 -228
      -355 -580 -595 -1005 -687 -150 -32 -446 -32 -600 0 -484 102 -870 399 -1092
      841 -210 419 -208 947 5 1372 142 285 353 504 654 680 l126 73 0 4266 c0 2729
      4 4289 10 4333 21 140 75 249 178 352 67 67 179 133 262 153 25 6 54 14 65 16
      38 9 220 -3 268 -18z"/>
      <path d="M2830 5136 l0 -1953 -77 -28 c-436 -154 -766 -531 -864 -985 -33
      -153 -33 -402 -1 -549 122 -545 540 -950 1082 -1047 125 -22 335 -22 460 0
      418 75 778 343 967 721 54 107 87 200 114 326 33 148 33 397 0 549 -98 454
      -428 831 -863 985 l-78 28 0 1953 0 1954 -370 0 -370 0 0 -1954z"/>
      </g>
      </svg>`;
      return icon;
    }

}